import Graphic from '../assets/divider.svg';

function Divider() {
    return <div className='divider'>
        <img src={Graphic} alt="Divider" />
    </div>;
}

export default Divider;
